<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW - ANIMAL VACCINE DETAIL</h2>
       <!--<p>Animal vaccine detail</p>-->
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3> &nbsp;  </h3>
       <div class="card mt-0">
       <div class="card-body">
       <div class="row">
       <!-- <div class="col-lg-4 col-sm-4 col-12">
          <p><span class="blue">Farm Name:&nbsp;</span><span id="farmname"></span></p>
          </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Species Name:&nbsp;</span><span id="speciesname" ></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Breed Name:&nbsp;</span><span id="breedname"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Animal ID:&nbsp;</span><span id="animalid"></span></p>
        </div>     <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Vaccination Date:&nbsp;</span><span id="vaccinedate" >{{testdate1 | date:'MM/dd/yyyy'}}</span></p>
        </div>-->
       
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Vaccine Name:&nbsp;</span><span id="VaccineName"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Batch No:&nbsp;</span><span id="batchno" ></span></p>
        </div>
        <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Expiry Date:&nbsp;</span><span id="ExpiryDate" >{{expiredate | date:'dd/MM/yyyy'}}</span></p>
        </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Dose Value/Units:&nbsp;</span><span id="dosevalue" ></span></p>
     </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Vaccine Date 1:&nbsp;</span><span id="vaccinedate1" >{{testdate | date:'dd/MM/yyyy'}}</span></p>
       </div>
        <div class="col-lg-4 col-sm-4 col-12">
          <p>
            <span class="blue">Remark:&nbsp;</span>
            <span id="remark"></span>
          </p>
        </div>
        </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)='backnavigate()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       <br>
       </div>
       </div>
     </div>
   </div>
 </div>
